<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="24" height="24" fill="url(#pattern0_5017_7)" />
    <defs>
      <pattern
        id="pattern0_5017_7"
        patternUnits="userSpaceOnUse"
        patternTransform="matrix(16.83 0 0 16.83 -1.20208 -1.20208)"
        preserveAspectRatio="none"
        viewBox="-1.41422 -1.41422 19.8 19.8"
        width="1"
        height="1"
      >
        <use
          xlink:href="#pattern0_5017_7_inner"
          transform="translate(-19.8 -19.8)"
        />
        <use
          xlink:href="#pattern0_5017_7_inner"
          transform="translate(0 -19.8)"
        />
        <use
          xlink:href="#pattern0_5017_7_inner"
          transform="translate(-19.8 0)"
        />
        <g id="pattern0_5017_7_inner">
          <line
            x1="4.29289"
            y1="24.2929"
            x2="24.2929"
            y2="4.29289"
            stroke="#FF0000"
            stroke-width="2"
          />
          <line
            x1="9.29289"
            y1="29.2929"
            x2="29.2929"
            y2="9.29289"
            stroke="#FF0000"
            stroke-width="2"
          />
          <line
            x1="-0.707107"
            y1="19.2929"
            x2="19.2929"
            y2="-0.707106"
            stroke="#FF0000"
            stroke-width="2"
          />
        </g>
      </pattern>
    </defs>
  </svg>
</template>
